import { defineMessages } from 'react-intl';

export default defineMessages({
    makeChanges: {
        id: 'ml.policychange.pupvehicles.Make Changes',
        defaultMessage: 'Make Changes'
    },
    reviewCoverages:{
        id:'ml.policychange.pupvehicles.We will review your coverages next',
        defaultMessage:'We will review your coverages next'
    },
    nextBaseDescription: {
        id: 'ml.policychange.pupvehicles.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.pupvehicles.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    saving: {
        id: 'ml.policychange.pupvehicles.saving',
        defaultMessage: 'Saving...'
    },
    addVehicleStep:{
        id:'ml.policychange.pupvehicles.Add Vehicle Step',
        defaultMessage:'Add Vehicle'
    },
    replaceVehicleStep:{
        id:'ml.policychange.pupvehicles.Replace Vehicle Step',
        defaultMessage:'Replace Vehicle'
    },
    editVehicleStep:{
        id:'ml.policychange.pupvehicles.Edit Vehicle Step',
        defaultMessage:'Edit Vehicle'
    },
    addVehicle:{
        id:'ml.policychange.pupvehicles.Add vehicle',
        defaultMessage:'Add vehicle'
    },
    replaceVehicle:{
        id:'ml.policychange.pupvehicles.Replace vehicle',
        defaultMessage:'Replace vehicle'
    },
    editVehicle:{
        id:'ml.policychange.pupvehicles.Edit vehicle',
        defaultMessage:'Edit vehicle'
    },
    underlyingPolicyNotListed: {
        id: 'ml.policychange.pupvehicles.Policy is not listed',
        defaultMessage: 'Policy is not listed'
    },
    xHasBeenAdded:{
        id:'ml.policychange.pupvehicles.x has been added',
        defaultMessage:'{strongName} has been added'
    },
    addPolicy: {
        id: 'ml.policychange.pupvehicles.Add Policy',
        defaultMessage: 'Add Policy'
    },
    cancel: {
        id: 'ml.policychange.pupvehicles.cancel',
        defaultMessage: 'Cancel'
    },
    addReplacedVehicle:{
        id: 'ml.policychange.pupvehicles.x will be removed from the policy. Please add the replacement vehicle below',
        defaultMessage: '{strongName} will be removed from the policy. Please add the replacement vehicle below.'
    },
    nonOwnerPolicyError: {
        id: 'ml.policychange.pupvehicles.You are not able to add a vehicle as a Non-Owner Policy was selected for the Umbrella Underlying policy',
        defaultMessage: 'You are not able to add a vehicle as a Non-Owner Policy was selected for the Umbrella Underlying policy. To proceed, remove the vehicle or update Policy information.'
    },
    vinOrSerialNumberRequired: {
        id: 'ml.policychange.pupvehicles..Vin Or Serial Number Required ',
        defaultMessage: 'VIN or Serial Number required when Vehicle Type is "Other"'
    }

})